export default __webpack_public_path__ + "static/media/guia-mobile-3.d365d98d.png";